import axios from 'axios';
import host from '../global';

const getAuthHeader = () => ({
  Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`,
});

export const checkJDPermissionsService = async () => {
  const response = await axios.get(`${host}/check_permissions_for_jd`, {
    headers: getAuthHeader(),
  });
  return response.data;
};

export const fetchJDDataService = async () => {
  const response = await axios.get(`${host}/orgadmin/get_jd_data`, {
    headers: getAuthHeader(),
  });
  return response.data;
};

export const deleteJDService = async (jd_id) => {
  const response = await axios.delete(`${host}/orgadmin/deletejd`, {
    headers: getAuthHeader(),
    params: { jd_id },
  });
  return response;
};

export const getJDByIdService = async (jd_id) => {
  const response = await axios.get(`${host}/getjd`, {
    headers: getAuthHeader(),
    params: { jd_id },
  });
  return response.data;
};

export const updateJDStatusService = async (jd_id, status) => {
  const response = await axios.put(
    `${host}/orgadmin/update-jd-status`,
    null,
    {
      headers: getAuthHeader(),
      params: { jd_id, status },
    },
  );
  return response;
};

export const generateShareableLinkService = async (job_id, job_role) => {
  const response = await axios.post(
    `${host}/generate-shareable-link`,
    { job_id, job_role },
    {
      headers: {
        ...getAuthHeader(),
        'Content-Type': 'application/json',
      },
    },
  );
  return response.data;
};
